import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import Icon from 'bf-library/Icon';

function renderStars(quantity) {
    const tempArray = Array.from({ length: quantity }, () => 0);
    return tempArray.map((value, index) => {
        const key = `${quantity}-stars-${index}`;
        return <Icon key={key} name="bf-icon-star-solid" />;
    });
}

const starsData = new Map([
    [ '5', renderStars(5) ],
    [ '4', renderStars(4) ],
    [ '3', renderStars(3) ],
    [ '2', renderStars(2) ],
    [ '1', renderStars(1) ],
]);

const mealPlansData = new Map([
    [ '1', <FormattedMessage id="bf.allInclusive" defaultMessage="bf.allInclusive" /> ],
    [ '10', <FormattedMessage id="bf.fullBoard" defaultMessage="bf.fullBoard" /> ],
    [ '11', <FormattedMessage id="bf.breakfast" defaultMessage="bf.breakfast" /> ],
    [ '12', <FormattedMessage id="bf.halfBoard" defaultMessage="bf.halfBoard" /> ],
    [ '100', <FormattedMessage id="bf.threeFourthBoard" defaultMessage="bf.threeFourthBoard" /> ],
]);

const propertyTypesData = new Map([
    [ '5', <FormattedMessage id="bf.cabinOrBungalow" defaultMessage="bf.cabinOrBungalow" /> ],
    [ '30', <FormattedMessage id="bf.resort" defaultMessage="bf.resort" /> ],
    [ '20', <FormattedMessage id="bf.hotel" defaultMessage="bf.hotel" /> ],
    [ '27', <FormattedMessage id="bf.motel" defaultMessage="bf.motel" /> ],
    [ '21', <FormattedMessage id="bf.inn" defaultMessage="bf.inn" /> ],
    [ '4', <FormattedMessage id="bf.bedAndBreakfast" defaultMessage="bf.bedAndBreakfast" /> ],
    [ '57', <FormattedMessage id="bf.luxury" defaultMessage="bf.luxury" /> ],
    [ '9', <FormattedMessage id="bf.conferenceCenter" defaultMessage="bf.conferenceCenter" /> ],
]);

const searchLabel = <FormattedMessage id="bf.search" defaultMessage="bf.search" />;
const priceRangeLabel = <FormattedMessage id="bf.priceRange" defaultMessage="bf.priceRange" />;
const countryLabel = <FormattedMessage id="bf.country" defaultMessage="bf.country" />;
const mealPlanLabel = <FormattedMessage id="bf.mealPlan" defaultMessage="bf.mealPlan" />;
const propertyTypeLabel = <FormattedMessage id="bf.propertyType" defaultMessage="bf.propertyType" />;
const starsRatingLabel = <FormattedMessage id="bf.starRating" defaultMessage="bf.starRating" />;
const noPreferenceLabel = <FormattedMessage id="bf.noPreference" defaultMessage="bf.noPreference" />;
const filterTitle = <FormattedMessage id="title.ibe.gui.filterby" defaultMessage="title.ibe.gui.filterby" />;
const alternativeDatesTitle = <FormattedMessage id="bm.filterSearch.alternativeDates" defaultMessage="bm.filterSearch.alternativeDates" />;
const alternativeDatesCheckboxLabel = <FormattedMessage
    id="hotel.setting.altcheckin.guestlabel"
    defaultMessage="hotel.setting.altcheckin.guestlabel"
/>;
const showMore = <FormattedMessage id="bf.showMore" defaultMessage="bf.showMore" />;
const showLess = <FormattedMessage id="bf.showLess" defaultMessage="bf.showLess" />;
const applyLabel = <FormattedMessage id="bf.apply" defaultMessage="bf.apply" />;

const searchInputIntlNotFindMessage = inputUser => (
    <FormattedHTMLMessage
        id="bf.notFindSuggestion"
        defaultMessage="bf.notFindSuggestion"
        values={{ search: inputUser }}
    />
);

const searchInputCategoriesLabels = {
    locations: (<FormattedMessage
        id="bf.locations"
        defaultMessage="bf.locations"
    />),
    properties: (<FormattedMessage
        id="bf.properties"
        defaultMessage="bf.properties"
    />),
    classifications: (<FormattedMessage id="bf.classifications" defaultMessage="bf.classifications" />),
};

const filterDataAndLabels = {
    starsData,
    mealPlansData,
    propertyTypesData,
    searchLabel,
    priceRangeLabel,
    countryLabel,
    mealPlanLabel,
    propertyTypeLabel,
    starsRatingLabel,
    noPreferenceLabel,
    searchInputCategoriesLabels,
    searchInputIntlNotFindMessage,
    filterTitle,
    alternativeDatesTitle,
    alternativeDatesCheckbox: alternativeDatesCheckboxLabel,
    showMore,
    showLess,
    applyLabel,
};

export default filterDataAndLabels;
